import { runInAction } from "mobx";

import { IntegrationsApi } from "@vromo/api";
import { IntegrationProfile, Platform, platforms } from "@vromo/models";
import { PageStore } from "./PageStore";
import { getRunEnv, isRunEnvProd } from "@vromo/utils";

/** local page storage setting */
export enum Setting {
    integrations,
    // configuring,
    api,
    allPlatforms
}

export type IntegrationsMap = Map<Platform, IntegrationProfile>

export const integrationsPageStore = new PageStore()
runInAction(() => {
    integrationsPageStore.settings[Setting.integrations] = new Map<Platform, IntegrationProfile>()
    integrationsPageStore.settings[Setting.api] = new IntegrationsApi()
    integrationsPageStore.settings[Setting.allPlatforms] = platforms[isRunEnvProd() ? "prod" : "dev"]
})
